import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import ChartUp from "../../assets/images/greenChart.svg";
import ChartDown from "../../assets/images/redChart.svg";
import color from "../../constants/color";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
const StatBox = ({ title, subtitle, icon, increase, decrease }) => {
  const theme = useTheme();

  return (
    <Box width="100%" m="0 10px" display="flex" flexDirection="row" alignItems="center" justifyContent="center" gap="30px">
      <Box display="flex" justifyContent="space-between">
        <Box sx={{ color: theme.palette.white.main, fontSize: "24px", height: "2rem", display: "flex", alignItems: "center" }}>
          {React.isValidElement(icon)
            ? React.cloneElement(icon, { sx: { ...icon.props?.sx, height: "2rem", width: "2rem" } })
            : icon}
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" mt="1%">
        <Box>
          <Typography
            variant="h6"
            sx={{ color: color.lightText, fontWeight: "500", fontSize: "22px" }}
          >
            {subtitle}
          </Typography>
          <Typography
            sx={{ color: color.text, fontWeight: "700", fontSize: "22px", textAlign: "center" }}
          >
            {title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StatBox;
